import { render, staticRenderFns } from "./SetupScreenshotAccountability.vue?vue&type=template&id=b09f1024&scoped=true&"
import script from "./SetupScreenshotAccountability.vue?vue&type=script&lang=js&"
export * from "./SetupScreenshotAccountability.vue?vue&type=script&lang=js&"
import style0 from "./SetupScreenshotAccountability.vue?vue&type=style&index=0&id=b09f1024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09f1024",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VExpandTransition})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b09f1024')) {
      api.createRecord('b09f1024', component.options)
    } else {
      api.reload('b09f1024', component.options)
    }
    module.hot.accept("./SetupScreenshotAccountability.vue?vue&type=template&id=b09f1024&scoped=true&", function () {
      api.rerender('b09f1024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setup/SetupScreenshotAccountability.vue"
export default component.exports